module.exports = __webpack_public_path__ + "img/codeen.cc107dc5.png";